import classNames from 'classnames';
import * as React from 'react';
import { IModulesLoadProps } from 'redux-state/layout/types.slots.js';

/** Wraps loaded modules with classes and info to identify modules */
export const ModulesLazyLoadWrapper = ({
  section,
  className,
  children,
}: Omit<IModulesLoadProps, 'modulePath' | 'moduleConfigArr'> & { children: React.ReactNode }) => {
  return (
    <div data-section={section} className={classNames('Slot', className)}>
      {children}
    </div>
  );
};
